import { HelpFooter as NumaHelpFooter } from '@numa-group/ui.help-footer';

import { PhoneIcon } from '@src/components/atoms/icons/phone';
import { useBrand } from '@src/contexts/brand-context';
import { useCmsContent } from '@src/contexts/cms-content-context';
import { useTrip } from '@src/contexts/trip-context';
import { useWhatsappQuery } from '@src/hooks/use-whatsapp';

import { EmailIcon } from './email-icon';
import { WhatsAppIcon } from './whats-app-icon';

const HelpFooter = () => {
  const content = useCmsContent();
  const { trip } = useTrip();
  const { data: whatsAppNumber } = useWhatsappQuery();
  const { isNativeBrand, brand } = useBrand();

  const phoneNumber =
    brand.contactMode === 'phone' && !!trip?.property?.phoneNumber ? trip.property.phoneNumber : undefined;

  // We only customize the brand colors if it's a native brand
  const nativeBrand = isNativeBrand
    ? {
        backgroundColor: brand.primaryColor,
        textColor: brand.textColor,
      }
    : undefined;

  const variant = isNativeBrand ? 'without-illustration' : 'default';

  return (
    <NumaHelpFooter
      brand={nativeBrand}
      variant={variant}
      title={content.helpFooterTitle}
      description={content.helpFooterText}
    >
      {phoneNumber && (
        <NumaHelpFooter.Link
          key="phone-help-link"
          icon={<PhoneIcon />}
          label={content.yesCallMe}
          href={`tel:${phoneNumber.replace(/\s/g, '')}`}
        >
          {phoneNumber}
        </NumaHelpFooter.Link>
      )}
      {!isNativeBrand && whatsAppNumber && (
        <NumaHelpFooter.Link
          key="whatsapp-help-link"
          icon={<WhatsAppIcon />}
          label={content.helpFooterWhatsappTitle}
          href={whatsAppNumber.link}
          isExternal
        >
          {whatsAppNumber.number}
        </NumaHelpFooter.Link>
      )}
      <NumaHelpFooter.Link
        key="email-help-link"
        icon={<EmailIcon />}
        label={content.helpFooterEmailTitle}
        href={`mailto:${brand.email}`}
        isExternal
      >
        {brand.email}
      </NumaHelpFooter.Link>
    </NumaHelpFooter>
  );
};
export default HelpFooter;
